<template>
  <meu-painel>
    <div class="voltar">
      <a href="/cadastroProdutor">Voltar</a>
    </div>
    <v-card-title>Listagem de Produtores</v-card-title>
    <input
      type="search"
      class="filtro"
      @input="filtro = $event.target.value"
      placeholder="Perquisar por CPF/CNPJ"
    />
    <br />
    <v-card-text v-for="(cliente, i) of produtoresFiltro()" :key="i">
      <v-card>
        <v-card-text>
          <p>
            <strong>Nome:</strong>
            {{cliente.client.name}}
          </p>
          <p>
            <strong>{{cliente.client.document}}:</strong>
            {{cliente.client.document === 'CPF' ? formatCpf(cliente.client.tax_id) : formatCnpj(cliente.client.tax_id)}}
          </p>
          <p v-if="!cliente.url">
            <strong>Link:</strong>
            Produtor ja realizou o processo
          </p>
          <p v-if="cliente.url">
            <strong>Link:</strong>
            {{cliente.url}}
          </p>
          <p v-if="!cliente.file">
            <strong>Documento:</strong>
            Produtor ainda não enviou o documento
          </p>
          <p v-if="cliente.file">
            <strong>Documento:</strong>
            <a :href="cliente.file" target="_blank">Clique aqui para ver documento</a>
          </p>
        </v-card-text>
      </v-card>
    </v-card-text>
    <div class="text-center">
      <v-pagination v-model="page" :length="Math.ceil(totalLinhas/15)" :total-visible="5"></v-pagination>
    </div>
    <br />
  </meu-painel>
</template>

<script>
import Painel from "../../components/Painel.vue";
import api from "../../services/api";
import dadosCliente from "../../models/dadosCliente";

export default {
  components: {
    "meu-painel": Painel
  },
  data() {
    return {
      dadosCliente: [],
      user: "",
      filtro: "",
      page: 1,
      totalLinhas: 0
    };
  },
  methods: {
    produtoresFiltro() {
      if (this.filtro) {
        let exp = new RegExp(this.filtro.trim(), "i");
        return this.dadosCliente.filter(cliente =>
          exp.test(cliente.client.tax_id)
        );
      } else {
        return this.dadosCliente;
      }
    },
    buscarDados() {
      api
        .get(`/clients?page=${this.page}`)
        .then(response => {
          this.dadosCliente = response.data.clients;
          this.totalLinhas = response.data.rows;
        })
        .catch(err => {
          if (err.response.status === 500) {
            alert("Não foi possivel conectar-se ao servidor");
          } else {
            alert(err.response.data.error);
          }
        });
    },
    formatCpf(cpf) {
      cpf = cpf.replace(/\D/g, "");
      cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
      cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      return cpf;
    },
    formatCnpj(cnpj) {
      cnpj = cnpj.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
        "$1.$2.$3/$4-$5"
      );
      return cnpj;
    }
  },
  mounted() {
    const usuario = localStorage.getItem("usuario");
    const auth = localStorage.getItem("token");

    if (!localStorage.getItem("usuario") && !localStorage.getItem("token")) {
      this.$router.push({ name: "login" });
      return;
    }
    this.user = JSON.parse(usuario);

    api.defaults.headers.Authorization = `Bearer ${JSON.parse(auth)}`;

    this.buscarDados();
  },
  watch: {
    page: function() {
      this.buscarDados();
    }
  }
};
</script>

<style>
ul {
  list-style-type: none;
}
li {
  border-bottom: 1px solid gray;
}
.filtro {
  display: block;
  margin-top: 20px;
  padding: 10px;
  width: 100%;
  border-radius: 20px;
  border: 1px solid gray;
}
.voltar {
  text-align: right;
}
.teste {
  list-style-type: none;
}
</style>